(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(leanProjectMonthlySavingsConfig);


	function leanProjectMonthlySavingsConfig (dashboardProvider) {
		// register widget
		dashboardProvider.widget(
			'leanProjectMonthlySavings', {
				name: 'Lean Project Cumulative Savings',
				description: 'Total savings, annual savings, one time savings, cost avoidance, or implementation costs of lean projects.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/lean-project-monthly-savings.png',
				categories: ['All', 'Lean Projects'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'leanProjectMonthlySavingsCtrl',
				templateUrl: '/application/f/dashboard/widgets/lean-project-monthly-savings.html',
				reload: true,
				isDrillDown: false,
				isEditable: true,
				resolve: {
					title: function (config) {
						if (config.title) {
							return config.title;
						}
					},
					type: function (config) {
						if (config.type) {
							return config.type;
						}
					},
					savingsType: function (config) {
						if (config.savingsType) {
							return config.savingsType;
						}
					}
				}
			}
		);
	}
})();
